import "../assets/styles/views/notifications.scss";
import { useState, useEffect } from "react";
import "../assets/styles/views/check-list.scss";
import { useLocation, useOutletContext } from "react-router-dom";
import NotificationCard from "../components/NotificationsCard";
import { get_message_list, set_message_read } from "../utils/endpoints";
import NotificationContent from "../components/panel-contents/NotificationContent";

export default function Notifications() {
  const [context, setContext] = useOutletContext();
  const [notifications, setNotifications] = useState();
  const [selected, setSelected] = useState();
  const [filter_news_active, setFiltersNewsActive] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (!!location && location?.state?.notifications_list) {
      setNotifications(location.state.notifications_list);
    } else if (context?.session) {
      (async () => {
        let response = await context.updateNotifications(context, true);
        if (response.result) setNotifications(response.data);
      })();
    }
    if (!!location && location?.state?.selected)
      setSelected(location.state.selected);
  }, [location, context.session]);

  useEffect(() => {
    setSelected();
  }, [filter_news_active]);

  useEffect(() => {
    if (selected) {
      if (context.device !== "dk") {
        context.openBottomPanel(
          <NotificationContent
            notification_info={selected}
            setSelected={setSelected}
          />,
          false
        );
      }
      if (!selected.read && context?.session) {
        (async () => {
          const response = await context.httpRequest(
            "put",
            set_message_read,
            [selected.id],
            context.session.token
          );
          if (response.result) {
            let response = await context.updateNotifications(context, true);
            if (response.result) setNotifications(response.data);
          }
        })();
      }
    }
  }, [selected]);

  return (
    <section className="notifications w-100 px-md-3 d-flex">
      <div className="notifications__info-message position-sticky m-3 mx-md-0 my-3 mt-md-5">
        <h1 className="my-0 w-100">Centro notifiche</h1>
      </div>
      <div className="notifications__filters-container d-flex align-items-center border-top mx-3 mx-md-0 mb-3 mb-md-0 py-2 py-md-3 px-3 px-md-0 position-sticky shadow-sm">
        {notifications ? (
          <span>
            <strong>{notifications.filter((x) => !x.read).length}</strong> nuove
            notifiche
          </span>
        ) : null}

        <div className="filter-button d-flex ms-auto">
          <button
            onClick={() => setFiltersNewsActive(false)}
            className={`py-2 px-3 border-0 d-block ${
              !filter_news_active ? "active" : ""
            }`}
          >
            Tutte
          </button>
          <button
            onClick={() => setFiltersNewsActive(true)}
            className={`py-2 px-3 border-0 ${
              filter_news_active ? "active" : ""
            }`}
          >
            Nuove
          </button>
        </div>
      </div>
      {!notifications || notifications.length === 0 ? (
        <span className="notifications__nothing-found-message d-none d-md-block w-100 text-center mt-4">
          Nessuna notifica
        </span>
      ) : null}

      <div className="notifications__container-list mb-md-5 d-md-flex main-panel w-100">
        <div className="notifications-list">
          {!notifications || notifications.length === 0 ? (
            <span className="d-block d-md-none w-100 text-center mt-5">
              Nessuna notifica
            </span>
          ) : (
            notifications.map((item, index) => {
              if ((filter_news_active && !item.read) || !filter_news_active)
                return (
                  <NotificationCard
                    notification_info={item}
                    setSelected={setSelected}
                    key={index}
                  />
                );
            })
          )}
        </div>
        <div className="notifications-content d-none d-md-block mx-auto w-100 ms-5 px-4 pb-4 shadow-sm border">
          {selected ? (
            <NotificationContent notification_info={selected} />
          ) : (
            <span className="not-selected-message d-block text-center mt-3 mt-md-5">
              Seleziona un messaggio da mostrare
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
